/**
 * PlatformOverview.jsx
 * ---------------------------------------------------------------------------
 * Section 2. Three-column pathway overview: Demand · Supply · Services.
 */

import React from "react";
import Section from "../ui/Section.jsx";
import { H2, Lede } from "../ui/Heading.jsx";
import { tokens } from "../../lib/tokens.js";

const COLUMNS = [
  {
    num: "01",
    title: "Demand",
    body: "Structured intake transforms raw legal inquiries into usable case data.",
  },
  {
    num: "02",
    title: "Supply",
    body: "Law firms receive organized, pre-screened case summaries.",
  },
  {
    num: "03",
    title: "Services",
    body: "AI enablement, economic analytics, and on-demand counsel.",
  },
];

export default function PlatformOverview() {
  return (
    <Section id="platform" label="I · Platform" tone="paper">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1.3fr",
          gap: 80,
          alignItems: "start",
        }}
      >
        <H2>A Unified Legal Intelligence Platform.</H2>
        <Lede style={{ marginTop: 8 }}>
          Three disciplined pathways — demand, supply, and enterprise services —
          operating as a single coherent system for the modern legal economy.
        </Lede>
      </div>

      <div
        style={{
          marginTop: 96,
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 64,
        }}
      >
        {COLUMNS.map((col) => (
          <div
            key={col.num}
            style={{ borderTop: `1px solid ${tokens.ink}`, paddingTop: 24 }}
          >
            <div
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 13,
                fontWeight: 500,
                color: tokens.inkSoft,
                letterSpacing: "0.2em",
                marginBottom: 36,
              }}
            >
              {col.num} / 03
            </div>
            <div
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 36,
                fontWeight: 400,
                color: tokens.ink,
                letterSpacing: "-0.01em",
                marginBottom: 20,
                lineHeight: 1,
              }}
            >
              {col.title}
            </div>
            <p
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                lineHeight: 1.65,
                color: tokens.inkSoft,
                margin: 0,
              }}
            >
              {col.body}
            </p>
          </div>
        ))}
      </div>
    </Section>
  );
}
